function n(e) {
  return e.replace("[", ".").replace("]", "");
}
const y = (e) => {
  const a = {};
  return Array.isArray(e.inner) && e.inner.length > 0 ? e.inner.reduce((r, { path: s, message: c, type: p }) => {
    const t = n(s ?? "");
    return r[t] === void 0 && (r[t] = []), r[t].push({ message: c, type: p }), r;
  }, a) : {
    [n(e.path ?? "")]: [{ message: e.message, type: e.type }]
  };
}, h = (e) => async (a) => {
  try {
    return {
      values: await e.validate(a, { abortEarly: !1 }),
      errors: {}
    };
  } catch (r) {
    return {
      values: a,
      errors: y(r)
    };
  }
};
export {
  h as yupResolver
};
